import { meterType, nameTypeByType } from './Meters.constants'

export const prvnTypes = {
	default: {
		id: meterType.PRVN,
		name: nameTypeByType(meterType.PRVN)
	}
}
